module.exports = __webpack_public_path__ + "img/16.558e5dfc.jpg";